import { FC, useState, useEffect, Fragment } from 'react';
import dayjs, { Dayjs } from 'dayjs';
// Components
import Prizes from 'components/Prizes';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  quizzes: any[];
  prizes: string[];
};

let now = dayjs();

const TextCountdown:FC<Props> = ({ quizzes, prizes }) => {
  const { t } = useTranslation();

  const [ end, setEnd ] = useState(false);
  const [ message, setMessage ] = useState<string | null>(null);

  useEffect(() => {
    const sortedQuizzes = [...quizzes].sort((a:any, b:any) => new Date(Number(a.startsDate)).getTime() - new Date(Number(b.startsDate)).getTime());

    const { endTime } = quizzes.reduce((acc:any, cur:any) => {
      const start = Number(cur.startsDate);
      const end = Number(cur.endsDate);
      acc['startTime'] = !acc.startTime ? start : start < acc.startTime ? start : acc.startTime;
      acc['endTime'] = !acc.endTime ? end : end > acc.endTime ? end : acc.endTime;
      return acc;
      // eslint-disable-next-line
    }, {});

    // const startDate = dayjs(startTime);
    const endDate = dayjs(endTime);

    if ( now.isAfter(endDate) ) setEnd(true);

    let nextTime:Dayjs | null = null;

    for ( let quiz of sortedQuizzes ){
      const quizStartDate = dayjs(Number(quiz.startsDate));
      if ( now.isBefore(quizStartDate) ){
        nextTime = quizStartDate;
        break;
      }
    }

    if ( nextTime ){
      setMessage(t('pages.quizGroup.nextQuizStarts', { date: dayjs(nextTime).format('MMMM D, YYYY') }))
    } else {
      const sortedEndDates = sortedQuizzes.map(q => q.endsDate).map(Number).sort((a:number, b:number) => a - b);
      setMessage(t('pages.quizGroup.winnersWillBeAnnounced', { date: dayjs(Number(sortedEndDates[sortedEndDates.length - 1])).format('MMMM D, YYYY') }))
    }
    // eslint-disable-next-line
  }, []);

  if (end) return null;
  return (
    <Fragment>
      <div className="text-primary text-center text-sm mb-4">{message}</div>
      {!!prizes.length ? <Prizes prizes={prizes} /> : null}
    </Fragment>
  )
}

export default TextCountdown;
